import { render, staticRenderFns } from "./SupportCaseDetail.vue?vue&type=template&id=1fd8022b&scoped=true"
import script from "./SupportCaseDetail.vue?vue&type=script&lang=js"
export * from "./SupportCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportCaseDetail.vue?vue&type=style&index=0&id=1fd8022b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8022b",
  null
  
)

export default component.exports